import RulesPanelTab from './RulesTab';
export default RulesPanelTab;
